var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6685 4.5219C16.6685 9.62727 9.09868 13.7597 8.77631 13.9304C8.69134 13.9761 8.59637 14 8.49989 14C8.40341 14 8.30844 13.9761 8.22347 13.9304C7.9011 13.7597 0.331299 9.62727 0.331299 4.5219C0.33265 3.32303 0.809497 2.17365 1.65723 1.32593C2.50495 0.478198 3.65433 0.00135127 4.8532 0C6.35928 0 7.67793 0.647653 8.49989 1.74239C9.32186 0.647653 10.6405 0 12.1466 0C13.3455 0.00135127 14.4948 0.478198 15.3426 1.32593C16.1903 2.17365 16.6671 3.32303 16.6685 4.5219Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.a26d10d748ee7fabede53aee29d5b0a0.svg";
export { ForwardRef as ReactComponent };